/* ============================================================
   RAJATHEE — Product page add-on UI ("Fall & Pico" / "Ready to Wear")
   Extracted from layout/theme.liquid for defer'd loading.
   Removes the document.body+subtree MutationObserver — Horizon
   re-renders add-to-cart-component via shopify:section:load,
   which we already handle.
   ============================================================ */
(function () {
  const isProductPage = window.location.pathname.includes('/products/');
  const isServiceProduct =
    window.location.pathname.includes('fall-pico-service') ||
    window.location.pathname.includes('ready-to-wear-service');
  if (!isProductPage || isServiceProduct) return;

  const ADDONS = [
    { label: 'Normal',        variantId: null,           price: 0,    desc: '' },
    { label: 'Fall & Pico',   variantId: 47195287748791, price: 180,  desc: '+₹180' },
    { label: 'Ready to Wear', variantId: 47195287781559, price: 1100, desc: '+₹1100' }
  ];

  window.__rjSelectedAddon = ADDONS[0];

  function isMainProductForm(el) {
    return (
      !el.closest('quick-add-component') &&
      !el.closest('.quick-add') &&
      !el.closest('product-card-component') &&
      !el.closest('.card-gallery') &&
      !el.closest('product-recommendations') &&
      !el.closest('[data-section-type="product-recommendations"]')
    );
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('button.rj-addon-btn');
    if (!btn) return;
    const wrapper = btn.closest('.rj-addons-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('button.rj-addon-btn').forEach(b => b.classList.remove('rj-selected'));
    btn.classList.add('rj-selected');
    const addonData = ADDONS.find(a => a.label === btn.dataset.addonLabel);
    if (addonData) {
      window.__rjSelectedAddon = addonData;
      const note = wrapper.querySelector('.rj-addon-note');
      if (note) {
        note.textContent = addonData.price > 0 ? `${addonData.label} service will be added to your order` : '';
      }
    }
  });

  function buildUI(atcComponent) {
    if (!isMainProductForm(atcComponent)) return;
    if (atcComponent.previousElementSibling?.classList.contains('rj-addons-wrapper')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'rj-addons-wrapper';
    const title = document.createElement('p');
    title.className = 'rj-addons-title';
    title.textContent = 'Add Ons';
    wrapper.appendChild(title);
    const btnRow = document.createElement('div');
    btnRow.className = 'rj-addons-buttons';
    const note = document.createElement('p');
    note.className = 'rj-addon-note';
    ADDONS.forEach((addon, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rj-addon-btn' + (i === 0 ? ' rj-selected' : '');
      btn.dataset.addonLabel = addon.label;
      btn.innerHTML = `<span>${addon.label}</span>${addon.price > 0 ? `<span class="rj-addon-btn-price">${addon.desc}</span>` : ''}`;
      btnRow.appendChild(btn);
    });
    wrapper.appendChild(btnRow);
    wrapper.appendChild(note);
    atcComponent.parentElement.insertBefore(wrapper, atcComponent);
  }

  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = (typeof input === 'string' ? input : input?.url) || '';
    if (url.includes('/cart/add') && init?.method?.toUpperCase() === 'POST') {
      const response = await _fetch.apply(this, arguments);
      if (window.__rjSelectedAddon && window.__rjSelectedAddon.variantId) {
        const productTitle = document.querySelector('h1')?.textContent?.trim() || document.title;
        const resData = await response.clone().json().catch(() => ({}));
        const parentKey = resData?.items?.[0]?.key || resData?.key || '';
        const sectionIds = [...new Set([...document.querySelectorAll('[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))];
        const addonBody = {
          items: [{ id: window.__rjSelectedAddon.variantId, quantity: 1, properties: { 'Add-on for': productTitle, '_parent_key': parentKey } }]
        };
        if (sectionIds.length) addonBody.sections = sectionIds.join(',');
        _fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(addonBody)
        }).then(r => r.json()).then(d => {
          if (d.sections) {
            Object.keys(d.sections).forEach(sectionId => {
              const el = document.querySelector('[data-section-id="' + sectionId + '"]');
              if (!el) return;
              const parsed = new DOMParser().parseFromString(d.sections[sectionId], 'text/html');
              const newEl = parsed.querySelector('[data-section-id="' + sectionId + '"]');
              if (newEl) el.innerHTML = newEl.innerHTML;
            });
          }
          ['cart:refresh', 'cart:updated', 'cart:update'].forEach(function(evName) {
            document.dispatchEvent(new CustomEvent(evName, { bubbles: true, detail: { resource: d, itemCount: d.item_count } }));
          });
        }).catch(e => console.warn('Rajathee addon failed:', e));
      }
      return response;
    }
    return _fetch.apply(this, arguments);
  };

  function init() { document.querySelectorAll('add-to-cart-component').forEach(buildUI); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
